/**
 * 将日期对象转换为 YYYYMMDD 格式的字符串
 * @param date 日期对象
 * @returns YYYYMMDD 格式的字符串，如果 date 为 null 则返回空字符串
 */
export function formatDateToYYYYMMDD(date: Date|string|null): string {
    if (!date) return '';
    const dateObj = new Date(date);
    return dateObj.getFullYear().toString() +
        (dateObj.getMonth() + 1).toString().padStart(2, '0') +
        dateObj.getDate().toString().padStart(2, '0');
}
